export default "__VITE_ASSET__Do1rgNM6__"